import Modal from "react-bootstrap/Modal";
import { BsCheckCircleFill } from "../../../assets/icons/vander";
import { usePatientSurgeryStore } from "../../hooks";
import {
  MainButton,
  InputForm as Input,
  LoadingData,
  ErrorMessage,
} from "../../ui";

export const DefineSessionsOriginModal = ({
  isOpen,
  setIsOpen,
  onSubmit,
  propsForm,
}) => {
  // Datos del hook ----------------------------------------//
  const {
    // Props
    patientSurgery,
  } = usePatientSurgeryStore();

  const { procedure } = patientSurgery.data;

  const {
    validateForm,
    formState,
    formValidation,
    eventsDefinedByChange,
    isLoading,
    showErrorMessage,
    messageText,
    onInputChange,
  } = propsForm;

  // States ------------------------------------------------//
  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//

  // Efectos -----------------------------------------------//
  return (
    <Modal
      show={isOpen}
      onHide={() => {
        setIsOpen(false);
      }}
      centered
      size="lg"
      keyboard={false}
      backdrop="static"
    >
      <Modal.Body>
        <div className="vstack gap-3">
          <BsCheckCircleFill
            className="icon text-success mx-auto"
            style={{ width: "48px", height: "48px" }}
          />
          <h1 className="mb-0 text-center">¡Cuestionario enviado con éxito!</h1>
          <div>
            <label className="form-label">
              ¡Gracias por compartirnos tu información! ¿Sabes cuántas sesiones
              de {procedure.procedure.title} debes agendar?
            </label>
            <div className="custom-control custom-radio custom-control-inline">
              <div className="form-check mb-0">
                <input
                  id="eventsDefinedByPatient"
                  className="form-check-input me-2"
                  readOnly
                  type="radio"
                  name="eventsDefinedBy"
                  value="PATIENT"
                  checked={formState.eventsDefinedBy === "PATIENT"}
                  onChange={eventsDefinedByChange}
                />
                <label
                  className="form-check-label fw-normal"
                  htmlFor="eventsDefinedByPatient"
                >
                  Sí, sé cuantas sesiones necesito.
                </label>
              </div>
              {formState.eventsDefinedBy === "PATIENT" && (
                <div className="d-lg-inline-block mb-2">
                  <Input
                    label={null}
                    type="number"
                    placeholder={null}
                    name="numberEvents"
                    validation={formValidation.numberEventsValid}
                    submit={validateForm}
                    value={formState.numberEvents}
                    onInputChange={onInputChange}
                  />
                  <p className="text-gray-600 fs-sm mb-0">
                    No podrás volver a cambiar este número.
                  </p>
                </div>
              )}
              <div className="form-check mb-0">
                <input
                  id="eventsDefinedByDoctor"
                  className="form-check-input me-2"
                  readOnly
                  type="radio"
                  name="eventsDefinedBy"
                  value="DOCTOR"
                  checked={formState.eventsDefinedBy === "DOCTOR"}
                  onChange={eventsDefinedByChange}
                />
                <label
                  className="form-check-label fw-normal"
                  htmlFor="eventsDefinedByDoctor"
                >
                  No, quiero una sesión por ahora.
                </label>
              </div>
              {formValidation.eventsDefinedByValid && validateForm && (
                <span className="text-danger">
                  {formValidation.eventsDefinedByValid}
                </span>
              )}
            </div>
          </div>
          {/* Mensajes */}
          {isLoading && <LoadingData />}
          {showErrorMessage && <ErrorMessage>{messageText}</ErrorMessage>}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <MainButton type="button" onClick={onSubmit} disabled={isLoading}>
          Confirmar
        </MainButton>
      </Modal.Footer>
    </Modal>
  );
};
